import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatPricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatGasPrice',
})
export class FormatGasPricePipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  formatPrice = function(value) {
    let str = String(value).replace(/[^0-9.]/g, ''),
      d = Number(str) || 0,
      b = d < 0 ? '-$' : '$';

    if (d <= 0) {
      return 'N/A';
    } else {
      return (
        '$' +
        d
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          .replace(/\.00$/, '')
      );
    }
  };

  transform(value: any, ...args) {
    return this.formatPrice(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-gas-price/format-gas-price.ts